import React from "react";

// ▲/▼ chip vs the prior period. Up is good on every number this tab shows, so
// up = green, down = soft gray (never red — a slow week is not an error).
export function Delta({ cur, prev, pts }: { cur: number | null; prev: number | null; pts?: boolean }) {
  if (cur == null || prev == null || (!pts && prev === 0)) {
    return <span className="gr-delta gr-delta-flat">vs prior: —</span>;
  }
  const diff = pts ? cur - prev : ((cur - prev) / prev) * 100;
  const val = `${Math.abs(diff).toFixed(1).replace(/\.0$/, "")}${pts ? " pts" : "%"}`;
  if (Math.abs(diff) < 0.05) return <span className="gr-delta gr-delta-flat">= prior</span>;
  return (
    <span className={`gr-delta ${diff > 0 ? "gr-delta-up" : "gr-delta-down"}`}>
      {diff > 0 ? "▲" : "▼"} {val}
    </span>
  );
}
